<template>
  <div id="keap-integration-drawer">
    <intergration-drawer-wrapper
      heading="Keap"
      :logo="InfusionKeap"
      sub-heading="Integration Settings"
      caption-title="Maropost will be able to :"
      docs-text="Integration with Keap."
      sub-heading-para="You can choose from multiple integation types to create various integration points with Keap. The integration requires creating a configuration setup here on Maropost and performing setup steps in your Keap account. For step-by-step instructions, refer to"
      docs-link="https://galaxy.maropost.com/s/article/Integration-with-Keap-New-UI"
    >
      <template #successMessage v-if="isNewConnection">
        <div class="ml-2 success-border mb-4">
          <v-row>
            <v-col cols="1" md="1" class="d-flex justify-end pr-0">
              <v-icon color="#3FD06F" style="font-size:35px;">
                mdi-checkbox-marked-circle
              </v-icon>
            </v-col>
            <v-col cols="11" md="11">
              <h2>Successfully Connected!</h2>
            </v-col>
          </v-row>
          <v-row no-gutters class="pb-4">
            <v-col cols="1" />
            <v-col cols="11" md="11">
              Your Maropost account is now conncted with Keap.
            </v-col>
          </v-row>
        </div>
        <v-divider class="pb-4" />
      </template>
      <template #form>
        <v-form
          ref="form"
          class="mx-2 pt-2"
          v-model="isFormValid"
          id="keap-integration-form"
        >
          <div class="d-flex mt-0">
            <v-autocomplete
              label="Select Integration Type"
              outlined
              id="keap-integration-type-dropdown"
              item-text="name"
              item-value="value"
              :disabled="isEditIntegration"
              :class="{ 'cursor-not-allowed': isEditIntegration }"
              :item-disabled="checkIsDisabled"
              :items="integrationTypes"
              v-model="payload.integrationType"
              :loading="areIntegrationsLoading || isLoading"
              :rules="[val => !!val || 'Integration Type is required.']"
            >
            </v-autocomplete>
          </div>
          <v-divider class="text-primary pb-4" />
          <v-expand-transition v-if="isIntergrationSelected">
            <div id="contact-import-settings">
              <h2 class="body-1">{{ integrationHeading }}</h2>
              <v-autocomplete
                label="Integrate with Maropost List"
                class="mt-4"
                id="keap-select-contact-import-settings-dropdown"
                outlined
                :menu-props="{
                  bottom: true,
                  offsetY: true,
                  maxWidth: 'auto'
                }"
                item-value="id"
                item-text="name"
                :search-input.sync="search"
                :loading="areContactsLoading"
                :items="contactLists"
                :rules="[val => !!val || 'Contact List is required.']"
                v-model="payload.list_id"
              >
                <template #append-item>
                  <v-responsive class="overflow-y-auto" max-height="400">
                    <span v-intersect="loadNextPage" />
                  </v-responsive>
                  <create-list-option
                    @open-list="contactDialog = !contactDialog"
                  />
                </template>
              </v-autocomplete>
              <template v-if="payload.integrationType == 'contacts_import'">
                <v-divider class="pb-1" />
                <IntegrationsCustomFieldMapping
                  sourceHeading="Keap Source"
                  targetHeading="Marketing Cloud Target"
                  v-model="mappedFields"
                  :sourceFields="keapFields"
                  :payload="payload"
                  integrationType="keap"
                  ref="integrationCustomFields"
                  @update-payload="updatePayload"
                />
              </template>
            </div>
          </v-expand-transition>
          <v-btn
            dark
            v-if="isFirstConnection"
            :loading="isConnecting"
            @click="connectStore"
            id="infusion-keap-connect-btn"
            class="mt-5 mb-5"
          >
            Connect
          </v-btn>

          <v-btn
            dark
            v-if="isEditStore"
            :loading="isSubmiting"
            class="mt-5 mb-5"
            id="infusion-keap-save-edit-btn"
            @click="addEditIntegration"
          >
            {{ isEditIntegration ? "Save" : "Add" }}
          </v-btn>
        </v-form>
      </template>
    </intergration-drawer-wrapper>
    <!-- Create new contact list drawer -->
    <v-dialog v-model="contactDialog" width="700">
      <create-list isbgWhite isDialog @close-drawer="closeDrawer" />
    </v-dialog>
  </div>
</template>

<script>
import isEmpty from "lodash/isEmpty";
import { IntegrationsMixin } from "@/mixins";
import debounce from "lodash/debounce";
import IntergrationDrawerWrapper from "@/components/shared/IntergrationDrawerWrapper.vue";
import { $lists, $connectorApp, $integrations } from "@/services";
import { mapGetters } from "vuex";
import InfusionKeap from "@/assets/conectiontab/infusion-keap.png";
import CreateListOption from "@/components/shared/CreateListOption.vue";
import constants from "@/constants.js";
import IntegrationsCustomFieldMapping from "@/components/shared/IntegrationsCustomFieldMapping.vue"
const { getIntegrationTypes } = $connectorApp;
const { RESPONSE_CODES } = constants;
import { getSplitKey } from '@/splitClient';

/**
 * Keap integeration add or update connection drawer
 */
export default {
  name: "KeapIntegrationDrawer",
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [IntegrationsMixin],
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      InfusionKeap,
      isConnecting: false,
      search: "",
      isFormValid: false,
      contactDialog: false,
      isLoading: false,
      isSubmiting: false,
      areIntegrationsLoading: false,
      integrationTypes: [],
      existingIntegrations: [],
      contactLists: [],
      contactRecords: 0,
      contactCurrentPage: 1,
      isConnectionValid: false,
      integrationType: "keap",
      currentConnection: null,
      payload: { integrationType: "", list_id: "" },
      keapFields: [],
      mappedFields: [
        { keap: '', maro: '' }
      ],
      rules: {
        required: value => !!value || " Field is Required.",
      }
    };
  },
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    CreateList : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ?  import('@/views/lists/lists/UIDCreateList.vue') : import('@/views/lists/lists/CreateList.vue') ,
    CreateListOption,
    IntergrationDrawerWrapper,
    IntegrationsCustomFieldMapping
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  mounted() {
    this.getKeapCustomFields();
  },
  computed: {
    /**
     * Maps store getters in the component
     */
    ...mapGetters({
      drawer: "ui/drawer"
    }),
    /**
     * Determines whether integration record is to be edited
     */
    isEditIntegration() {
      const { right } = this.drawer;
      return right && !isEmpty(right.item);
    },
    /**
     * Determines whether an integration is selected or not
     */
    isIntergrationSelected() {
      return !isEmpty(this.payload.integrationType);
    },
    /**
     * Has more data available for contact list
     */
    moreDataToAvailable() {
      return this.contactRecords > this.contactLists.length;
    },
    /**
     * Connection of the id to edit
     */
    connectionId() {
      return this.drawer.right.storeId;
    },
    /**
     * Determines whether connection is new or not
     */
    isNewConnection() {
      return !!this.$route.query.crm_id;
    },
    /**
     * Connection id of keap connection
     */
    crmId() {
      return this.$route.query.crm_id || this.drawer.right.storeId;
    },
    /**
     * Success message to be shown in snackbar
     */
    successMessage() {
      return !this.isEditIntegration
        ? `Successfully added.`
        : "Connection updated successfully.";
    },
    integrationHeading() {
      let heading = ""
      switch(this.payload.integrationType){
        case "contacts_import":
          heading = "Contact Import Settings"
        break
        default:
          heading = "Orders With Contacts Settings"
        break
      }
      return heading;
    }
  },
  /**
  |--------------------------------------------------
  | Watches properties
  |--------------------------------------------------
  */
  watch: {
    isIntergrationSelected(val) {
      if (val) this.getContactsList();
    },
    /**
     * Search contact list by name
     */
    search() {
      this.contactCurrentPage = 1;
      this.lazyLoadContacts();
    },
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    updatePayload(val) {
      this.payload = val;
    },
    getKeapCustomFields(){
      $connectorApp.getCustomFields('keap')
      .then(res => {
        this.keapFields = res.data;
      })
    },
    /**
     * Determines whether integration type is disabled or not
     */
    checkIsDisabled({ value }) {
      return this.existingIntegrations.findIndex(val => val === value) > -1;
    },
    /**
     * Fetch details of a keap connection
     */
    async getKeapConnection() {
      try {
        this.isLoading = true;
        await this.regenrateToken();
        const { data } = await $connectorApp.getConnection(
          this.integrationType,
          this.crmId
        );
        this.currentConnection = data;
        this.isConnectionValid = !isEmpty(data);

        // Shows error message to the user that connection not found
        if (!this.isConnectionValid) {
          this.showInvalidConnectionMsg();
        }
      } catch (error) {
        this.isConnectionValid = true;
        this.showInvalidConnectionMsg();
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Shows error message to the user if connection is invalid
     * and then closes add edit keap drawer
     */
    showInvalidConnectionMsg() {
      this.$store.commit("ui/snackbar", {
        message: "Connection not found.",
        type: "error"
      });
      this.addStore();
    },
    /**
     * Fetches list of all the keap connections
     * @returns {Array} List of keap connections
     */
    async getKeapConnections() {
      try {
        if (!this.currentConnection) return;
        this.isLoading = true;
        let { data } = await $integrations.getStoresList({
          crm_type: this.integrationType
        });

        data = data.filter(({ name }) => name === this.currentConnection.name);
        if(this.isEditIntegration){
          let tempData = data.filter(row => {
            return row.integration_type == 'contacts_import'
          });
          if(!isEmpty(tempData)){
            this.payload.mapped_fields = tempData[0].data;
          }
          if(this.payload.integrationType == 'contacts_import'){
            await this.$refs.integrationCustomFields.loadMappedFieldsonEdit();
          }
        }
        // Filters unique records by integration_type property
        this.existingIntegrations = [
          ...data
            .reduce(
              (acc, curr) => acc.set(curr["integration_type"], curr),
              new Map()
            )
            .keys()
        ];
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Sends http (PUT)request to add and update a keap integration detail
     */
    async addEditIntegration() {
      if (!this.isFormValid) return this.$refs.form.validate();
      try {
        this.isSubmiting = true;

        if(this.payload.integrationType == 'contacts_import'){
          await this.$refs.integrationCustomFields.mappedFieldsHash();
        } else {
          delete this.payload.mapped_fields;
        }

        const { item } = this.drawer.right;
        const payload = { ...this.payload };

        // Add and remove payload properties if an integration have to be updated
        if (this.isEditIntegration && item && item.id) {
          payload["crmlist_id"] = item.id;
          payload["crm_id"] = item.crm_id;
        }
        const { status } = await $connectorApp.addConnection(
          this.drawer.right.storeId,
          payload
        );
        let message = this.successMessage;
        if (status === RESPONSE_CODES.success) {
          this.$store.commit("ui/snackbar", {
            message,
            type: "success"
          });
        }
        this.showIntegrationDetails();
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.isSubmiting = false;
      }
    },
    /**
     * Shows keap integration detail drawer on the basis of the isEditIntegration property
     */
    showIntegrationDetails() {
      this.drawerName = `KeapDetailDrawer`;
      if (this.isEditIntegration) this.addStore({ isCreated: true });
      else {
        this.addStore({
          isCreated: true,
          show: true,
          integration: { ...this.payload, crmId: this.crmId }
        });
      }
    },
    /**
     * Fetches list integration types
     */
    async getIntegrationsList() {
      try {
        this.areIntegrationsLoading = true;
        const { data } = await getIntegrationTypes("keap");
        this.integrationTypes = !isEmpty(data)
          ? data.map(value => ({ name: this.underscoreRemover(value), value }))
          : [];
      } catch (error) {
        this.showErrorMessage(error);
      } finally {
        this.areIntegrationsLoading = false;
      }
    },
    /**
     * Load next page contacts data for contact list record
     */
    loadNextPage() {
      if (this.areContactsLoading) return;
      this.contactCurrentPage++;
      this.getContactsList();
    },
    /**
     * Connects store for the first time
     */
    connectStore() {
      if (!this.isFormValid) return this.$refs.form.validate();
      this.checkConnectorAppToken();
    },
    /**
     * Fetches list of contacts list of selected integration type
     */
    async getContactsList(query = {}) {
      try {
        this.areContactsLoading = true;
        const params = {
          page: this.contactCurrentPage,
          per_page: 10,
          sort_order: "asc",
          no_folder: true,
          ...query
        };

        const { data } = await $lists.getList({ params });
        this.contactLists = [...this.contactLists, ...data.data.lists];
        this.contactRecords = data.data.meta.count;
      } catch (error) {
        this.$store.commit("ui/snackbar", {
          message: error.message,
          type: "warning"
        });
      } finally {
        this.areContactsLoading = false;
      }
    },
    /**
     * Lazy load contacts
     */
    lazyLoadContacts: debounce(function() {
      this.getContactsList({ name: this.search });
    }, 1000),
    /**
     * Closes drawer and fetches updated contact list of selected integration
     */
    closeDrawer(data) {
      if (data) {
        this.contactLists.push(data);
        this.payload.list_id = data.id;
      }
      this.contactDialog = false;
      this.getContactsList();
    }
  },
  /**
  |--------------------------------------------------
  | Created lifecycle hook
  |--------------------------------------------------
  */
  async created() {
    const { right } = this.drawer;
    this.getIntegrationsList();
    if (right && right.item) {
      const { item } = right;
      this.payload.list_id = item.list_id;
      this.payload.integrationType = item.integration_type;
      await this.getContactsList();
      const hasContact =
        this.contactLists.findIndex(({ id }) => id === item.list_id) >= 0;
      if (!hasContact) this.contactLists.push(item.list);
    }

    await this.getKeapConnection();
    this.getKeapConnections();
  }
};
</script>

<style lang="scss" scoped>
#create-new-contact-list {
  height: 36px;
  background-color: #1e2533;
  color: #ffffff !important;
}
.success-border {
  border: 2px solid #29993e;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
